import React from 'react';
import { testimonialShots } from '../data/salesContent';
export function Testimonials() {
  return <section className="bg-bone px-5 py-14 sm:px-8" data-id="element-112" data-mp="3kq4775fr2wnq">
      <div className="mx-auto max-w-6xl" data-id="element-113" data-mp="3ksgwy4rr2bbc">
        <h2 className="text-center font-display text-[24px] font-bold text-plum sm:text-[30px]" data-id="element-114" data-mp="3fyvxs9ef7bak">
          Testimonios
        </h2>
        <p className="mt-3 text-center text-[13px] text-neutral-600" data-id="element-115" data-mp="3b01gxd00jwt3">
          Mensajes reales de lectoras · datos personales ocultos por privacidad
        </p>

        <div className="mt-9 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-116" data-mp="31zd24g2spsf5">
          {testimonialShots.map(shot => <figure key={shot.src} className="overflow-hidden rounded-2xl border border-plum/10 bg-white p-2 shadow-[0_12px_32px_-24px_rgba(45,27,78,0.6)]" data-id="element-117" data-mp="2x1upofpkkv2e">
              <img src={shot.src} alt={shot.alt} loading="lazy" className="w-full rounded-xl" data-id="element-118" data-mp="v8dmbo8h2gdg" />
            </figure>)}
        </div>
      </div>
    </section>;
}